"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const _isFn = /*#__PURE__*/ _interopRequireDefault(require("./isFn"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 *
 * @remarks
 * [Reference](https://chakra-ui.com/docs/components/menu/usage#accessing-the-internal-state)
 *
 * @param valueOrFn - any datatype value
 *
 * @param args - parameter that will be passed if the value is a function
 *
 * @returns execute a fn or return the value
 *
 * @example
 * ```tsx
 * const Component = (props) => {
 *
 * const {children} = props;
 *
 * const isOpen = false;
 *
 * return <>{runIfFn(children, {isOpen})}</>;
 * }
 * ```
 *
 * ============================================================
 *
 * ```tsx
 * <Component>
 *   {({ isOpen }) =>
 *      <div>This shop is {isOpen ? 'open' : 'closed'}</div>
 *   }
 * </Component>
 * ```
 */ function runIfFn(valueOrFn) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, _isFn.default)(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}
const _default = runIfFn;
